/**
 * Generate a random integer that is between two values.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random#Getting_a_random_integer_between_two_values
 * @param min - The minimum number (by default inclusive)
 * @param max - The maximum value that can be generated (by default exclusive)
 * @param inclusive - Whether both values are inclusive or exclusive, or they can be individually inclusive/exclusive
 * (default={inclusiveMin: true})
 * @returns The randomly generated number
 */
export function getRandomInt(
    min: number,
    max: number,
    inclusive: boolean | { inclusiveMax?: boolean; inclusiveMin?: boolean } = { inclusiveMin: true },
): number {
    let inclusiveMin: boolean;
    let inclusiveMax: boolean;
    if (typeof inclusive === 'boolean') {
        inclusiveMin = inclusive;
        inclusiveMax = inclusive;
    } else {
        inclusiveMin = inclusive.inclusiveMin ?? false;
        inclusiveMax = inclusive.inclusiveMax ?? false;
    }
    const intMin = Math.ceil(min + (inclusiveMin ? 0 : 1));
    const intMax = Math.floor(max + (inclusiveMax ? 1 : 0));
    if (intMin >= intMax) {
        throw new Error('Min and max need to have numbers between them');
    }
    return Math.floor(Math.random() * (intMax - intMin)) + intMin;
}
